import { render, staticRenderFns } from "./view.vue?vue&type=template&id=ae12faa4"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae12faa4')) {
      api.createRecord('ae12faa4', component.options)
    } else {
      api.reload('ae12faa4', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=ae12faa4", function () {
      api.rerender('ae12faa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/csg/sku/ordinary/view.vue"
export default component.exports